import CryptoJS from "crypto-js";

// 秘钥：必须是 16/24/32 位
// const KEY = CryptoJS.enc.Utf8.parse("1234567890123456");
// 偏移量：必须是 16 位
const IV = CryptoJS.enc.Utf8.parse("1234567890123456");

export default {
  // 加密
  encrypt(key, word) {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    const keyStr = CryptoJS.enc.Utf8.parse(key);
    let encrypted = CryptoJS.AES.encrypt(srcs, keyStr, {
      iv: IV,
      mode: CryptoJS.mode.CBC, // 常用 CBC 模式
      padding: CryptoJS.pad.Pkcs7, // 常用 Pkcs5 填充
    });
    return encrypted.toString();
  },

  // 解密
  decrypt(key, word) {
    const keyStr = CryptoJS.enc.Utf8.parse(key);

    let decrypt = CryptoJS.AES.decrypt(word, keyStr, {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },

  generateRandomAESKey(len = 16) {
    // 生产随机key
    // 生成随机字节
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let res = "";
    for (let i = 0; i < len; i++) {
      // 使用时间戳加随机数增加熵值
      res += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    // 返回一个 CryptoJS 可以识别的 Utf8 格式对象
    return res;
  },
};
